module.exports = __webpack_public_path__ + "img/import-status.8f636933.svg";